import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import {AlertRedIcon} from './icons/alert-red-icon';
// Icons
import {InformationBlueIcon} from './icons/information-blue-icon';

// Styles
import styles from './comment-alert.module.css';

const CommentAlert = ({children, type, className}) => {
  const isTypeError = type === 'error';

  const alertClassNames = clsx({
    [styles.info]: !isTypeError,
    [styles.error]: isTypeError
  },
  styles.alertWrapper,
  className
  );

  return (
    <div className={alertClassNames}>
      {
        isTypeError
          ? <AlertRedIcon className={styles.alertIcon} />
          : <InformationBlueIcon className={styles.alertIcon} />
      }

      {children}
    </div>
  );
};

CommentAlert.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  type: PropTypes.oneOf(['error', 'info']).isRequired,
  className: PropTypes.string
};

CommentAlert.defaultProps = {
  className: ''
};

export default CommentAlert;
